import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { DmsFile } from '../../modal/upload/model/upload.model';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-evaluation-of-eoi',
    standalone: false,
    templateUrl: './evaluation-of-eoi.component.html',
    styleUrl: './evaluation-of-eoi.component.scss'
})
export class EvaluationOfEoiComponent {
    @Input() stepDetails: any;
    @Input() isEditable: boolean = false;
    @Input() proposalName: any;
    @Input() schemeType: any;
    @Input() step: any;
    @Input() id: any
    @Output() routeConfig: EventEmitter<any> = new EventEmitter();
    payload: {
    proposal_id: any;
    proposal_name: any;
    scheme: any;
    schemeId: any;
  };
  allDmsFiles: any[]=[];
  rfpdata: any;
  file: File;
  aonDetailsForm: FormGroup;
   selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;

     constructor(
 
    private messageService: MessageService,
   
    private route: ActivatedRoute,
    private api: ApiService,
    private fb: FormBuilder,
    
  ){}
    

    ngOnInit(): void {
    
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const scheme = params['scheme'];
      const schemeId = params['scheme'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        scheme: scheme,
        schemeId: schemeId
      }
    });
     this.aonDetailsForm = this.fb.group({
    final_offer: [''],
    installation_date: [''],
    delivery_date: [''],
    offer: [''],
    final_cost: [''],
    tec_table: ['']
  });
    this.getAccordOfAONDetails();
    
  }

  onSubmit(): void {
    // if (this.commentForm.valid) {
    
    const formData = new FormData();
    formData.append('proposal_step', this.id);
     const getValue = (key: string) => {
    return this.aonDetailsForm.get(key)?.value || '';
  };
   
formData.append('justification', getValue('final_offer'));
  formData.append('installation_date', getValue('installation_date'));
  formData.append('delivery_date', getValue('delivery_date'));
  formData.append('offer', getValue('offer')); // TEXT value
  formData.append('final_cost', getValue('final_cost'));
  formData.append('tec_table', getValue('tec_table'));
    if (this.file) {
      formData.append('offer', this.file);
    }
    let url;
    if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/accord/aon-details/`
    }  

    if (this.rfpdata?.id) {
      this.api.putAPI(url + this.rfpdata?.id + '/', formData).subscribe((res: any) => {
        this.finalOfferFilePath = res?.file || null;
        this.selectedFinalOfferFile = null;

        this.getAccordOfAONDetails();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
    } else {
      this.api.postAPI(url, formData).subscribe((res: any) => {
        this.selectedFinalOfferFile = null;
        this.finalOfferFilePath = res?.file || null;
        this.getAccordOfAONDetails();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data  uploaded successfully' });
        // this.stepCompleted.emit(); 
      });
    }

  }

  getAccordOfAONDetails() {
    let url;
    url =`/make1/accord/aon-details/`
    
    this.api.getAPI(url + `?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
      .subscribe((res: any) => {
        if (!res) return;
        // ✅ Handle both array or single object response
        const data = Array.isArray(res) ? res[0] : res;
        this.rfpdata = data;
        console.log('this is final offer', this.rfpdata);
          const dmsFiles: DmsFile[] = this.rfpdata.dms_files;
            this.allDmsFiles = dmsFiles;
        // this.commentForm.patchValue({
        //   final_offer: data?.justification || '',
        //   installation_date: data?.installation_date || '',
        //   delivery_date: data?.delivery_date || '',
        //   offer: data?.offer || '',
        //   final_cost: data?.final_cost || '',
        //   tec_table: data?.tec_table || getTenderOpeningSheetTemplate('TEC table',this.stepDetails),
        // });
        // ✅ Set existing file path safely
        // this.finalOfferFilePath = data?.offer || null;
        // this.selectedFinalOfferFile = null;
        // console.log('Final Offer File Path:', this.finalOfferFilePath);
      });
  }
}
